import { createSelector } from "reselect";

import { getReports } from "../root.selectors";
import { ReportsState, Zoom } from "./reports.types";
import {
  ReportsPeriod,
  CsvExportState,
} from "../../helpers/reports.helper.types";

export const getReportsPeriod = createSelector(
  [getReports],
  (reportsSlice: ReportsState): ReportsPeriod => reportsSlice.period
);
export const getSelectedReportsProfile = createSelector(
  [getReports],
  (reportsSlice: ReportsState): string => reportsSlice.profile
);
export const getReportsZoom = createSelector(
  [getReports],
  (reportsSlice: ReportsState): Zoom => reportsSlice.zoom
);
export const getReportsZoomVisible = createSelector(
  [getReportsZoom],
  (reportsZoom: Zoom): boolean => reportsZoom.visible
);
export const getZoomStart = createSelector(
  [getReportsZoom],
  (reportsZoom: Zoom): number => reportsZoom.start
);
export const getZoomEnd = createSelector(
  [getReportsZoom],
  (reportsZoom: Zoom): number => reportsZoom.end
);
export const getCSVExportState = createSelector(
  [getReports],
  (reportsSlice: ReportsState): CsvExportState => reportsSlice.csvExportState
);
